import { withStyles } from '@material-ui/styles';
import TimeLineItem from './HubLockLogItem';
import styles from './styles';

export default withStyles(styles)(TimeLineItem);
